import { styled } from '@stitches/react'

import { COLORS } from '~/core/colors'

export const Content = styled('div', {
  flex: 1,
  backgroundColor: COLORS.PRIMARY,
  flexDirection: 'column',
})
